export const privacy = {
  it: {
    title: "Informativa sulla Privacy",
    section1: {
      title: "1. Informazioni che Raccogliamo",
      content: "Raccogliamo le informazioni che ci fornisci direttamente, incluso:",
      items: [
        "Informazioni dell'account (email, password)",
        "Informazioni di identificazione personale (nome, indirizzo, telefono)",
        "Informazioni aziendali (nome azienda, ruolo, settore)",
        "Dati di utilizzo e analisi",
        "Preferenze di comunicazione",
        "Informazioni tecniche sui tuoi dispositivi e navigazione"
      ]
    },
    section2: {
      title: "2. Come Utilizziamo le tue Informazioni",
      content: "Utilizziamo le informazioni raccolte per:",
      items: [
        "Fornire e mantenere i nostri servizi",
        "Migliorare l'esperienza utente",
        "Inviare aggiornamenti e notifiche importanti",
        "Elaborare transazioni e gestire il tuo account",
        "Analizzare i modelli di utilizzo e ottimizzare le prestazioni",
        "Rispettare gli obblighi legali",
        "Prevenire frodi e migliorare la sicurezza"
      ]
    },
    section3: {
      title: "3. Sicurezza dei Dati",
      content: "Implementiamo misure tecniche e organizzative appropriate per proteggere le tue informazioni personali:",
      items: [
        "Crittografia dei dati in transito e a riposo",
        "Valutazioni e audit regolari della sicurezza",
        "Controlli di accesso e autenticazione",
        "Monitoraggio continuo e rilevamento delle minacce",
        "Formazione dei dipendenti sulla protezione dei dati"
      ]
    },
    section4: {
      title: "4. Condivisione e Divulgazione dei Dati",
      content: "Potremmo condividere le tue informazioni con:",
      items: [
        "Fornitori di servizi e partner commerciali",
        "Autorità legali quando richiesto dalla legge",
        "Terze parti con il tuo consenso esplicito",
        "Società affiliate all'interno del nostro gruppo aziendale"
      ]
    },
    section5: {
      title: "5. I tuoi Diritti",
      content: "Ai sensi delle leggi sulla protezione dei dati applicabili, hai il diritto di:",
      items: [
        "Accedere ai tuoi dati personali",
        "Correggere dati inaccurati",
        "Richiedere la cancellazione dei tuoi dati",
        "Opporti al trattamento dei dati",
        "Portabilità dei dati",
        "Revocare il consenso",
        "Presentare un reclamo alle autorità di controllo"
      ]
    },
    section6: {
      title: "6. Cookie e Tracciamento",
      content: "Utilizziamo cookie e tecnologie simili per:",
      items: [
        "Ricordare le tue preferenze",
        "Analizzare l'utilizzo del sito",
        "Personalizzare i contenuti",
        "Migliorare la funzionalità del sito"
      ]
    },
    section7: {
      title: "7. Trasferimenti Internazionali di Dati",
      content: "I tuoi dati potrebbero essere elaborati in paesi al di fuori del tuo paese di residenza. Garantiamo appropriate misure di salvaguardia attraverso:",
      items: [
        "Clausole contrattuali standard",
        "Accordi sul trattamento dei dati",
        "Conformità con i quadri normativi internazionali"
      ]
    },
    section8: {
      title: "8. Conservazione dei Dati",
      content: "Conserviamo le tue informazioni per il tempo necessario a:",
      items: [
        "Fornire i nostri servizi",
        "Rispettare gli obblighi legali",
        "Risolvere controversie",
        "Far rispettare gli accordi"
      ]
    },
    section9: {
      title: "9. Contattami",
      content: "Per domande relative alla privacy, contatta il nostro Responsabile della Protezione dei Dati:",
      contact: {
        title: "Informazioni di Contatto"
      }
    },
    section10: {
      title: "10. Aggiornamenti di questa Informativa",
      content: "Potremmo aggiornare periodicamente questa Informativa sulla Privacy. L'ultima versione sarà pubblicata su questa pagina con la data di entrata in vigore."
    },
    lastUpdated: "Ultimo aggiornamento"
  },
  en: {
    title: "Privacy Policy",
    section1: {
      title: "1. Information We Collect",
      content: "We collect information that you provide directly to us, including:",
      items: [
        "Account information (email, password)",
        "Personal identification information (name, address, phone)",
        "Business information (company name, role, industry)",
        "Usage and analytics data",
        "Communication preferences",
        "Technical information about your devices and browsing"
      ]
    },
    section2: {
      title: "2. How We Use Your Information",
      content: "We use the collected information to:",
      items: [
        "Provide and maintain our services",
        "Improve user experience",
        "Send important updates and notifications",
        "Process transactions and manage your account",
        "Analyze usage patterns and optimize performance",
        "Comply with legal obligations",
        "Prevent fraud and enhance security"
      ]
    },
    section3: {
      title: "3. Data Security",
      content: "We implement appropriate technical and organizational measures to protect your personal information:",
      items: [
        "Encryption of data in transit and at rest",
        "Regular security assessments and audits",
        "Access controls and authentication",
        "Continuous monitoring and threat detection",
        "Employee training on data protection"
      ]
    },
    section4: {
      title: "4. Data Sharing and Disclosure",
      content: "We may share your information with:",
      items: [
        "Service providers and business partners",
        "Legal authorities when required by law",
        "Third parties with your explicit consent",
        "Affiliated companies within our corporate group"
      ]
    },
    section5: {
      title: "5. Your Rights",
      content: "Under applicable data protection laws, you have the right to:",
      items: [
        "Access your personal data",
        "Correct inaccurate data",
        "Request deletion of your data",
        "Object to data processing",
        "Data portability",
        "Withdraw consent",
        "File a complaint with supervisory authorities"
      ]
    },
    section6: {
      title: "6. Cookies and Tracking",
      content: "We use cookies and similar technologies to:",
      items: [
        "Remember your preferences",
        "Analyze site usage",
        "Personalize content",
        "Improve site functionality"
      ]
    },
    section7: {
      title: "7. International Data Transfers",
      content: "Your data may be processed in countries outside your country of residence. We ensure appropriate safeguards through:",
      items: [
        "Standard contractual clauses",
        "Data processing agreements",
        "Compliance with international regulatory frameworks"
      ]
    },
    section8: {
      title: "8. Data Retention",
      content: "We retain your information for as long as necessary to:",
      items: [
        "Provide our services",
        "Comply with legal obligations",
        "Resolve disputes",
        "Enforce agreements"
      ]
    },
    section9: {
      title: "9. Contact Us",
      content: "For privacy-related questions, contact our Data Protection Officer:",
      contact: {
        title: "Contact Information"
      }
    },
    section10: {
      title: "10. Updates to this Policy",
      content: "We may periodically update this Privacy Policy. The latest version will be posted on this page with the effective date."
    },
    lastUpdated: "Last updated"
  }
};